import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// Bootstrap Vue
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// import '@babel/polyfill'


Vue.config.productionTip = false


// https://gist.github.com/james2doyle/4aba55c22f084800c199
// vue.pretty-bytes.filter.js
Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
});

Vue.filter('currency', function (num) {
  if(typeof num === "string") {
    num = parseFloat(num);
  }
  if (typeof num !== 'number' || isNaN(num)) {
    // throw new TypeError('Expected a number');
    num = 0;
  }
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
});

// jacked from: https://github.com/sindresorhus/pretty-bytes
Vue.filter('digit', function (num) {
  if(typeof num === "string") {
    num = parseFloat(num);
  }
  if (typeof num !== 'number' || isNaN(num)) {
    // throw new TypeError('Expected a number');
    num = 0;
  }
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
});

Vue.filter('ratio', function (num) {
  if(typeof num === "string") {
    num = parseFloat(num);
  }
  if (typeof num !== 'number' || isNaN(num)) {
    // throw new TypeError('Expected a number');
    num = 0;
  }
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
